import { API } from "../../../api/constants"
import { authenticatedAxiosInstance } from "../../../auth/AuthenticatedAxios"

// ==================================================== DASHBOARD =====================================================  //

export const refreshStatistics = (data: { monthStart: Date; monthEnd: Date }) =>
    authenticatedAxiosInstance.patch(API + `/dashboard/finance/${data.monthStart}/${data.monthEnd}`).then((res) => res.data)

export const getFinanceStatistics = (data: { monthStart: Date; monthEnd: Date }) =>
    authenticatedAxiosInstance.get(API + `/dashboard/finance/${data.monthStart}/${data.monthEnd}`).then((res) => res.data)

export const getEmployeeStatistics = (key: string) =>
    authenticatedAxiosInstance.get(API + `/dashboard/employee/${key}`).then((res) => res.data)

export const getObjectStatistics = (key: string) =>
    authenticatedAxiosInstance.get(API + `/dashboard/object/${key}`).then((res) => res.data)

export const getCustomerStatistics = (key: string) =>
    authenticatedAxiosInstance.get(API + `/dashboard/customer/${key}`).then((res) => res.data)

// ==================================================== COST CENTERS =====================================================  //

export const getCostCenterNames = () =>
    authenticatedAxiosInstance.get(API + `/cost-centers/names`).then((res) => res.data)



